module.exports = __webpack_public_path__ + "static/media/3DPPA21.b1e5946e.jpg";